import { useQuery } from 'data-fetching-client';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { DescriptionList } from 'foundations-components/transitional/components/DescriptionList';
import { H7 } from 'foundations-components/transitional/components/H7';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { Section } from 'foundations-components/transitional/components/Section';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { View } from 'foundations-components/components/View';
import { productToTranslationKey } from '../../utils';
import { utcToRolloutOffsetLocal } from '../../../app/utils/dateUtils';
import { GET_ROLLOUT_TYPES } from '../../queries';
import { CustomerFacingProducts } from '../../ProductTypes';
import RolloutFeatureGroups from '../RolloutFeatureGroups';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RolloutProductDetailsPanelTabDetails = ({
  rolloutProductUpdate
}) => {
  const {
    featureGroups,
    releaseDate,
    rollout: {
      approvedAt,
      enrollmentStatus,
      products,
      type
    },
    rolloutState
  } = rolloutProductUpdate;
  const customerFacingProducts = products.filter(product => CustomerFacingProducts.has(product));
  const {
    data: rolloutTypesData
  } = useQuery(GET_ROLLOUT_TYPES);
  const rolloutTypes = (rolloutTypesData === null || rolloutTypesData === void 0 ? void 0 : rolloutTypesData.rolloutTypes) || new Map();
  return /*#__PURE__*/_jsxs(Section, {
    "data-test-id": "details-panel-details-tab-content",
    children: [/*#__PURE__*/_jsx(H7, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.detailsPanel.updateInformation"
      })
    }), /*#__PURE__*/_jsxs(DescriptionList, {
      children: [/*#__PURE__*/_jsx("dt", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.detailsPanel.type"
        })
      }), /*#__PURE__*/_jsx("dd", {
        children: rolloutTypes.has(type) ? /*#__PURE__*/_jsx(Paragraph, {
          children: rolloutTypes.get(type)
        }) : /*#__PURE__*/_jsx(Paragraph, {
          children: "--"
        })
      }), /*#__PURE__*/_jsx("dt", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.detailsPanel.app"
        })
      }), /*#__PURE__*/_jsx("dd", {
        children: /*#__PURE__*/_jsx(RolloutFeatureGroups, {
          featureGroups: featureGroups
        })
      }), /*#__PURE__*/_jsx("dt", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.detailsPanel.products"
        })
      }), /*#__PURE__*/_jsx(View, {
        marginBlockStart: "100",
        as: "dd",
        children: customerFacingProducts.length > 0 ? customerFacingProducts.map(product => /*#__PURE__*/_jsx(Tag, {
          marginInlineStart: "0",
          marginInlineEnd: "200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `app.products.${productToTranslationKey(product)}`
          })
        }, product)) : '--'
      }), (rolloutState === 'PRIVATE_BETA' || rolloutState === 'PUBLIC_BETA') && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(H7, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.detailsPanel.betaEnrollment"
          })
        }), /*#__PURE__*/_jsx("dt", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.detailsPanel.dateEnrolled"
          })
        }), /*#__PURE__*/_jsx("dd", {
          children: approvedAt ? /*#__PURE__*/_jsx(FormattedDateTime, {
            type: "userTz",
            value: approvedAt,
            format: "LL"
          }) : releaseDate ? /*#__PURE__*/_jsx(FormattedDateTime, {
            type: "userTz",
            value: utcToRolloutOffsetLocal(releaseDate).valueOf(),
            format: "LL"
          }) : '--'
        }), /*#__PURE__*/_jsx("dt", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.detailsPanel.betaType"
          })
        }), /*#__PURE__*/_jsx("dd", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `app.statusTags.${rolloutState}`
          })
        }), /*#__PURE__*/_jsx("dt", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.detailsPanel.whoEnrolled"
          })
        }), /*#__PURE__*/_jsx("dd", {
          children: enrollmentStatus === 'ENROLLED_CANNOT_LEAVE' || enrollmentStatus === 'CANNOT_ENROLL' ? '--' : /*#__PURE__*/_jsx(FormattedMessage, {
            message: `app.enrollmentStatus.${enrollmentStatus}`
          })
        })]
      })]
    })]
  });
};
export default RolloutProductDetailsPanelTabDetails;